import React from 'react';
import { TouchableOpacity } from 'react-native';

import { Box, Text } from '@components/Restyle';
import Icon from '@components/shared/Icon/Icon';

type Props = {
  title: string;
  iconName: string;
  onPress?: () => void;

  disabled?: boolean;
  activeOpacity?: number;
  accessibilityLabel?: string;

  iconBgColor?: string;
  iconColor?: string;
  iconSize?: 's' | 'm' | 'l' | 'xl' | string;

  my?: any;
  mx?: any;
};

export const NavItemRow: React.FC<Props> = ({
  title,
  iconName,
  onPress,
  disabled = false,
  activeOpacity,
  accessibilityLabel,
  iconBgColor = 'greenSecondary',
  iconColor = 'white',
  iconSize = 'l',
  my = 'xs',
  mx = 'm',
}) => {
  const isPressable = !!onPress && !disabled;

  return (
    <Box my={my} mx={mx} key={`nav-${title}`}>
      <TouchableOpacity
        onPress={onPress}
        activeOpacity={activeOpacity ?? (isPressable ? 0.2 : 1)}
        disabled={!isPressable}
        accessibilityLabel={accessibilityLabel ?? title}>
        <Box flexDirection='row' alignItems='center'>
          <Box
            alignItems='center'
            justifyContent='center'
            width={40}
            height={40}
            borderRadius='l'
            marginRight='xs'
            backgroundColor={iconBgColor as any}>
            <Icon
              name={iconName}
              variant={iconSize as any}
              color={iconColor as any}
            />
          </Box>

          <Text variant='labelEmphasized' color='textPrimary'>
            {title}
          </Text>
        </Box>
      </TouchableOpacity>
    </Box>
  );
};
